"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
/**
 * Component that is blue to show that it is a link and responds to clicks
 * Also has a dropdown component if dropdown items are specified
 */
const LinkComponent = (props) => {
    const renderRemove = (0, react_1.useMemo)(() => {
        if (props.onRemove) {
            return (react_1.default.createElement("span", { className: "link-component-remove", onClick: props.onRemove },
                react_1.default.createElement("i", { className: "fa fa-remove" })));
        }
        return null;
    }, [props.onRemove]);
    const renderDropdownItem = (item) => {
        const id = 'id' in item ? item.id : item.value;
        const name = 'name' in item ? item.name : item.label;
        // Handle divider
        if (name == null) {
            return react_1.default.createElement("li", { className: "divider" });
        }
        // Get a string key
        let key = id;
        if (typeof key !== 'string') {
            key = JSON.stringify(key);
        }
        return (react_1.default.createElement("li", { key: key },
            react_1.default.createElement("a", { key: id, className: "dropdown-item", onClick: () => props.onDropdownItemClicked?.(id) }, name)));
    };
    const elem = (react_1.default.createElement("div", { className: "link-component", "data-bs-toggle": props.dropdownItems ? "dropdown" : undefined },
        react_1.default.createElement("div", { style: { display: "inline-block" }, onClick: props.onClick }, props.children),
        renderRemove));
    const dropdown = props.dropdownItems ? (react_1.default.createElement("div", { className: "dropdown", style: { display: "inline-block" } },
        elem,
        react_1.default.createElement("ul", { className: "dropdown-menu", style: { cursor: "pointer" } }, props.dropdownItems.map(renderDropdownItem)))) : null;
    // Simple case
    if (!props.onClick &&
        !props.onRemove &&
        (!props.dropdownItems || props.dropdownItems.length === 0)) {
        return react_1.default.createElement("div", { className: "link-component-readonly" }, props.children);
    }
    return props.dropdownItems ? dropdown : elem;
};
exports.default = LinkComponent;
